import script from "./Landing.vue?vue&type=script&lang=ts&setup=true"
export * from "./Landing.vue?vue&type=script&lang=ts&setup=true"

import "./Landing.vue?vue&type=style&index=0&id=973d1f9c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-973d1f9c"]])

export default __exports__